import { getBookingStatus } from "../../lib/utils";
import type { Event } from "../../lib/types";
import { Badge } from "../ui/Badge";

type Variant = "card" | "badge";

/**
 * Shows limited / sold-out messaging from booking + capacity status (public API price points).
 * Use `variant="badge"` for the same pill style as Cancelled (list headers, dialogs).
 */
export function EventScarcityBanner({
  event,
  variant = "card",
}: {
  event: Event;
  variant?: Variant;
}) {
  if (event.isCancelled || !event.startsAt) {
    return null;
  }
  const status = getBookingStatus(
    event.pricePoints,
    event.bookingClosesAt,
    event.startsAt,
  );

  if (variant === "badge") {
    if (status === "limited") {
      return (
        <Badge variant="warning" size="sm" role="status" className="shrink-0">
          Limited Places Remaining
        </Badge>
      );
    }
    if (status === "full") {
      return (
        <Badge variant="error" size="sm" role="status" className="shrink-0">
          Fully Booked
        </Badge>
      );
    }
    return null;
  }

  if (status === "limited") {
    return (
      <div
        className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900"
        role="status"
      >
        Limited Places Remaining
      </div>
    );
  }
  if (status === "full") {
    return (
      <div
        className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900"
        role="status"
      >
        Fully Booked
      </div>
    );
  }
  return null;
}
